import { mapView } from './view';
import { clone, head, propOr } from 'ramda';
import { protectedRoute } from '../../../_runtime/routing/ProtectedRoute';
import ErrorBoundary from '../../../components-common/errors/ErrorBoundary';
import { selectNonEmptyValues } from '@dirootie-toolbox/objects';
import { ConfigElement } from '@components-fabric/types';
import { getScreenId } from '../utils';
import { mapRoute } from './route';
import { emptyScreenTemplate } from '../empty-screen';

const mapComponents = (obj: ConfigElement, context?: any) => {
  const result = {
    protected: protectedRoute,
    errorBoundary: ErrorBoundary,
    layout: head(
      selectNonEmptyValues(
        ['layout', 'components.layout', 'section.layout', ''],
        obj
      )
    ),
  };
  return result;
};

export const mapScreenBase = (obj: ConfigElement) => {
  const context = emptyScreenTemplate;
  const cloned = clone(context) as any;
  cloned.id = getScreenId(obj as any);
  cloned.cat = 'screen';
  cloned.type = 'custom';
  cloned.view = mapView(obj, cloned);
  cloned.route = mapRoute(obj, cloned);
  cloned.components = mapComponents(obj, cloned);
  cloned.section = propOr(undefined, 'section', obj);
  return cloned;
};
